/**
 * The web Links section's source: a typed page's relationship-field links in
 * both directions, from the project's tracker records, plus its body links in
 * both directions from the team's page links index (`webPageLinks.ts`) when
 * this console can ask it. Without the index answer (offline, or a server
 * without it) the section still shows the field links.
 */
import type { WebPageLinksSource, WebTrackerPageLink } from '../collab/webPageLinks';

export interface ConsolePageLinksOptions<Link> {
  /** `fieldRelationLinks` over the current records, from the shared page module. */
  fieldLinks: (itemId: string) => Link[];
  bodyLinks: Pick<WebPageLinksSource, 'linksFor'> | null;
}

export function createConsolePageLinksSource<Link extends WebTrackerPageLink>(options: ConsolePageLinksOptions<Link>) {
  return {
    async linksFor(itemId: string): Promise<Array<Link | WebTrackerPageLink>> {
      const fields = options.fieldLinks(itemId);
      const body = options.bodyLinks ? await options.bodyLinks.linksFor(itemId).catch(() => null) : null;
      return body ? [...fields, ...body.links] : fields;
    },
  };
}
